import { SwitchFieldWrapper, WrappedInputProps } from '@/common/components/Form/FormFieldWrapper.tsx'
import React from 'react'
import { useController, useWatch } from 'react-hook-form'
import { cn } from '@/utils/style.ts'
import { useFormSection } from '@/common/components/Form/useFormSection.tsx'
import { ClassValue } from 'clsx'
import { Switch } from 'antd'

type FormSwitchProps = {
  //
} & WrappedInputProps

export const FormSwitch: React.FC<FormSwitchProps> = ({
  name,
  label,
  description,
  className,
  disabled,
  wrapperClassName,
}) => {
  const { fieldName } = useFormSection(name)
  const { field } = useController({ name: fieldName, defaultValue: false })
  const value = useWatch({ name: fieldName }) // don't add defaultValue to it

  return (
    <SwitchFieldWrapper
      className={wrapperClassName}
      name={name}
      label={label}
      description={description}
      disabled={disabled}
    >
      <SwitchInput className={className} value={value} onChange={field.onChange} disabled={disabled} />
    </SwitchFieldWrapper>
  )
}

type SwitchInputProps = {
  className?: ClassValue
  value: boolean
  onChange: (arg: boolean) => void
  disabled?: boolean
}
export const SwitchInput: React.FC<SwitchInputProps> = ({ className, value, onChange, disabled }) => {
  return (
    <Switch
      className={cn('[&>span]:w-[18px] [&>span]:h-[18px]', 'h-[22px] w-[42px]',
        'data-[state=checked]:bg-emerald-500', 'data-[state=unchecked]:bg-red-500', className,
      )}
      checked={value}
      onChange={onChange}
      disabled={disabled}
    />
  )
}
